import { Component, OnInit } from '@angular/core';
import { AccountsService } from 'src/app/shared/services/accounts/accounts.service';
import { ActivatedRoute, Router } from '@angular/router';
import { HuddlesService } from 'src/app/shared/services/huddle/huddles.service';

import * as _ from 'lodash';
import { NgIf, NgClass } from '@angular/common';
import { HuddleSummaryComponent } from '../summary/huddle-summary/huddle-summary.component';
import { AllHuddlesComponent } from '../all-huddles/all-huddles.component';
import { AllActionPlansComponent } from '../all-action-plans/all-action-plans/all-action-plans.component';
import { AllSuggestionsComponent } from '../all-suggestions/all-suggestions/all-suggestions.component';
import { AllSpotlightsComponent } from '../all-spotlights/all-spotlights/all-spotlights.component';
@Component({
    selector: 'app-project-huddle-home',
    templateUrl: './project-huddle-home.component.html',
    styleUrls: ['./project-huddle-home.component.scss'],
    imports: [NgIf, NgClass, HuddleSummaryComponent, AllHuddlesComponent, AllActionPlansComponent, AllSuggestionsComponent, AllSpotlightsComponent]
})
export class ProjectHuddleHomeComponent implements OnInit {

  tabType = {
    SUMMARY: 'summary',
    ALL_HUDDLES: 'all-huddles',
    ALL_ACTION_PLANS: 'all-action-plans',
    ALL_SUGGESTIONS: 'all-suggestions',
    ALL_SPOTLIGHTS: 'all-spotlights'
  }
  activeTab: string = this.tabType.SUMMARY;
  huddleBrandId: string | null = null;
  loading:boolean = true;
  huddleEnable: boolean = false;
  spotlightsData: any; // Store
  spotlights: string | null = null;
  startDate: any = '';
  brandDetails: any = '';
  endDate: any = '';
  selectedLevel: string | null = null;
  options: { [key: string]: string } | null = null;

  constructor(private _accountService: AccountsService,
    private route: ActivatedRoute,
    private huddleService: HuddlesService,
    private router: Router,

  ) { }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      this.huddleBrandId = params['project_id'];
      this.activeTab = params['active_tab'] || this.tabType.SUMMARY;
      this.tabChangeHandler(this.activeTab)
      if (this.huddleBrandId) {
        this.getBrandDetail(this.huddleBrandId);
      }
    });

    this.huddleService.spotlights$.subscribe(spotlights => {
      this.spotlights = spotlights;
    });
  }
  getCurrentTab(): string {
    return this.huddleService.getCurrentTab();
  }

  // Method to change the current tab
  tabChangeHandler(tab: string): void {
    this.activeTab = tab;
    this.huddleService.setCurrentTab(tab);

    // Update the URL with the new tab value
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { active_tab: this.activeTab },
      queryParamsHandling: 'merge' // keeps other query params
    });
  }
  getBrandDetail(brandId: string): void {
    this.huddleEnable = true;
    this._accountService.getBrandDetail(brandId).subscribe(
      (response) => {

        this.brandDetails = response?.data?.brand?.action_management_configuration

        const huddleAvailable = !!response?.data?.brand?.action_management_configuration?.huddle;
        if (huddleAvailable) {

          this.huddleEnable = true;
        } else {
          this.huddleEnable = false;
        }
        // Safely access nested actions and spotlights using optional chaining
        const actions = response?.data?.brand?.action_management_configuration?.huddle?.modules?.actions?.config?.brand_id;
        const spotlights = response?.data?.brand?.action_management_configuration?.huddle?.modules?.spotlights?.config?.brand_id;
        const escalations = response?.data?.brand?.action_management_configuration?.huddle?.modules?.escalations?.config?.brand_id;
        if (actions) {
          this.huddleService.setActions(actions);
        } else {
          console.warn('Actions not found in the response');
        }
        if (spotlights) {
          this.huddleService.setSpotlights(spotlights);
        } else {
          console.warn('Spotlights not found in the response');
        }

        if (escalations) {
          this.huddleService.setEscalations(escalations);
        } else {
          console.warn('escalations not found in the response');
        }
        this.loading = false;
      },
      (error) => {
        console.error("Error while getting brand details.");
        this.loading = false;
      }
    );
  }


}

